import React from 'react';
import PropTypes from 'prop-types';
import { ThemeProvider } from 'styled-components';
import commonProps from './common/common-props';
import { Page } from './common/styles';
import Header from './common/header';
import Hero from './our-story-elements/hero';
import Mission from './our-story-elements/mission';
import Values from './our-story-elements/values';
import Story from './our-story-elements/story';
import Career from './our-story-elements/career';
import PartnerWithUs from './our-story-elements/partner-with-us';

export default function OurStory(props) {
  const common = commonProps();
  const state = {
    ...props,
    ...common,
    light: false,
  };

  return (
    <ThemeProvider theme={state}>
      <Page>
        <Header />
        <Hero />
        <Mission />
        <Values />
        <Story />
        <PartnerWithUs />
        <Career />
      </Page>
    </ThemeProvider>
  );
}

/* eslint-disable react/no-unused-prop-types */
OurStory.propTypes = {
  logo: PropTypes.string.isRequired,
  hero: PropTypes.string.isRequired,
  heroPortrait: PropTypes.string.isRequired,
  ourStory: PropTypes.string.isRequired,
  values: PropTypes.arrayOf(PropTypes.string).isRequired,
  partnerWithUsImage: PropTypes.string.isRequired,
};
/* eslint-enable react/no-unused-prop-types */
